import {
  GetAssignmentsForAssignableRequest,
  GetAssignmentsForAssignableResponse,
} from '@eigtech/assignments-types'
import { Corn, isCorn } from '@eigtech/shared-corn'
import {
  contextualGet,
  queryOptions,
  useQueries,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from '@eigtech/ui-shared-api'
import { assignmentsBasePath, assignmentsQueryKeys } from './constants'

export const getAssignmentsForAssignable = ({ assignableId }: GetAssignmentsForAssignableRequest) =>
  contextualGet<GetAssignmentsForAssignableResponse>(
    `${assignmentsBasePath}/assignable/${assignableId}`
  )

export const getAssignmentsForAssignableQueryOptions = (entityId: Corn) =>
  queryOptions({
    queryKey: assignmentsQueryKeys.assignable.assignments(entityId),
    queryFn: () => getAssignmentsForAssignable({ assignableId: entityId }),
    enabled: !!entityId && isCorn(entityId),
  })

export const useGetAssignmentsForAssignable = (entityId: Corn) =>
  useQuery(getAssignmentsForAssignableQueryOptions(entityId))
export const useGetAssignmentsForAssignableSuspense = (entityId: Corn) =>
  useSuspenseQuery(getAssignmentsForAssignableQueryOptions(entityId))

export const useGetAssignmentsForAssignables = (entityIds: Corn[]) =>
  useQueries({
    queries: entityIds.map((id) => getAssignmentsForAssignableQueryOptions(id)),
  })

export function useInvalidateAssignmentsForAssignable() {
  const queryClient = useQueryClient()

  return function invalidateAssignmentsForAssignable(entityId: Corn) {
    queryClient.invalidateQueries({
      queryKey: getAssignmentsForAssignableQueryOptions(entityId).queryKey,
    })
  }
}
